import {
  PayoutAccount,
  PayoutAccountsApi,
} from 'modules/host-payout-methods/models/PayoutAccount';
import { StripeConnect } from 'modules/host-payout-methods/models/PayoutFieldName';
import req from 'utils/req';

export function getByAccountId({ accountId }: { accountId: string }) {
  return req(
    `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details/`,
  ).get() as Promise<PayoutAccountsApi>;
}

export function save({
  accountId,
  payoutAccount,
}: {
  accountId: string;
  payoutAccount: PayoutAccount;
}) {
  if (payoutAccount.id) {
    return req(
      `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details/${payoutAccount.id}`,
    ).put(payoutAccount) as Promise<void>;
  }
  return req(
    `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details/`,
  ).post(payoutAccount) as Promise<void>;
}

export function create({
  accountId,
  payoutAccount,
}: {
  accountId: string;
  payoutAccount: PayoutAccount;
}) {
  return req(
    `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details`,
  ).post(payoutAccount) as Promise<{
    payoutMethod: {
      method: PayoutAccount;
    };
  }>;
}

export type StripeOnboardingResponse = {
  onboardingLink: string;
  payoutMethodId: string;
};

export function fetchStripeOnboardingLink({
  accountId,
  payoutAccount,
  returnRefreshUrl,
}: {
  accountId: string;
  payoutAccount: PayoutAccount;
  returnRefreshUrl: string;
}): Promise<StripeOnboardingResponse> {
  const url = `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details/${payoutAccount.id}/onboardingLink`;
  return req(url).post({
    stripeAccountId: (payoutAccount.details as StripeConnect)
      .stripeConnectAccountId,
    refreshUrl: returnRefreshUrl,
    returnUrl: returnRefreshUrl,
  });
}

export type StripeDashboardResponse = {
  loginLink: string;
  payoutMethodId: string;
};

export function fetchStripeDashboardLink({
  accountId,
  payoutAccount,
}: {
  accountId: string;
  payoutAccount: PayoutAccount;
}): Promise<StripeDashboardResponse> {
  const url = `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details/${payoutAccount.id}/loginLink`;
  return req(url).post({
    stripeAccountId: (payoutAccount.details as StripeConnect)
      .stripeConnectAccountId,
  });
}

export function remove({
  accountId,
  payoutAccount,
}: {
  accountId: string;
  payoutAccount: PayoutAccount;
}) {
  return req(
    `${URL_API_HOST}/api/v1/finance/host/${accountId}/payout-details/${payoutAccount.id}`,
  ).delete() as Promise<void>;
}
